import { ContainerProps } from '@zervant/reactcomponents'
import { ComponentClass } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import { StateInterface } from '../Interfaces/StateInterface'
import { ACTIONS } from './Actions'
import { Datadog } from './Datadog'

type StateToPropsType<T> = (state: StateInterface) => T
type DispatchToPropsType = (dispatch: Dispatch<any>, ownProps?: any) => any

export function Controller<PropertiesInterface = { [key: string]: any }>(
  mapStateToProps: StateToPropsType<PropertiesInterface>,
  mapDispatchToProps?: DispatchToPropsType,
) {
  return function (component: ComponentClass<PropertiesInterface>) {
    return connect(
      (state: StateInterface) => {
        let props: any = {
          ongoing: {},
          errors: [],
        }
        try {
          props = mapStateToProps(state)
          props.ongoing = state.ongoing
          props.errors = state.errors
        } catch (error) {
          Datadog.addError(error, {
            component: 'Controller',
          })
          console.error(error)
        }
        return props
      },
      (dispatch: Dispatch<any>, ownProps: any) => {
        return Object.assign(
          bindActionCreators(ACTIONS, dispatch),
          mapDispatchToProps && mapDispatchToProps(dispatch, ownProps),
        )
      },
    )(component)
  }
}
